const COUCH_AND_LAMP_IMAGE = '/images/tourney-dashboard/sofa.png';

interface Props {
  message: string;
  hint?: string;
  iconSrc?: string;
}

export default function SectionEmptyState({ message, hint, iconSrc = COUCH_AND_LAMP_IMAGE }: Props) {
  return (
    <div className="flex flex-col items-center gap-ds-lg py-12">
      <img src={iconSrc} alt="" className="size-8" />
      <div className="typography-product-body-highlight text-center text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        <p>{message}</p>
        {!!hint && <p>{hint}</p>}
      </div>
    </div>
  );
}
